import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-xx-large);
	display: flex;
	flex-direction: column;
	padding: var(--gap) 0;
	gap: var(--gap);

	/* TOOLBAR */
	.filter-search-wrapper {
		display: flex;
		justify-content: space-between;
		gap: var(--gap);
		.filter-search-wrap {
			width: 23.7%;
		}
		.oversight-project-actions {
			display: flex;
			gap: var(--gap);
		}
	}
`;
